import client from './client';

export default {
  // async currentUser() {
  //   const response = await client.get('current-user/');
  //   return response.data;
  // },

  async updateUserProfile(data) {
    const response = await client.patch('current-user/', data);
    return response.data;
  },

  async patchProfileImage(data) {
    const response = await client.patch('account/profile-image/', data);
    return response.data;
  },

  async updatePassword(data) {
    const response = await client.patch('account/password/change/', data);
    return response.data;
  },

  async logout() {
    const response = await client.post('logout/');
    return response.data;
  },

  async getTimezone() {
    const response = await client.get('time-zones/');
    return response.data;
  },

  async requestGHL() {
    const response = await client.get('account/ghl-link/');
    return response.data;
  },

  /**
   * Check GHL link status
   * Polls the GHL link endpoint to check if the magic link has been generated
   *
   * @returns {Object} Status object with ghl_magic_link
   *
   * Expected response structure:
   * {
   *   ghl_magic_link: string | null,
   *   ghl_magic_link_update_at: string | null
   * }
   */
  async checkGHLStatus() {
    console.log('Checking GHL status...');
    const response = await client.get('account/ghl-link/');
    console.log('GHL status response:', response.data);
    return response.data;
  },
};
